var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loadedconfig)?_c('div',{staticClass:"list-group border-radius-2 no-border"},[_c('WidgetHeader',{attrs:{"link":"/reports/report/progress"}},[_vm._v(_vm._s(_vm.$t('progress')))]),_c('div',{staticClass:"list-group-item p-8"},[_c('Report',{attrs:{"loadedconfig":_vm.loadedconfig}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }